import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import type { IncomeSource } from 'src/pages/loan/income/data';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import {
  toIncomeSource,
  toLoanIncomePayload,
  type LoanIncomeDto,
} from './mapLoanIncome';

export interface UpdateLoanIncomeParams {
  loanId: string;
  row: IncomeSource;
}

const updateLoanIncome: MutationFunction<
  IncomeSource,
  UpdateLoanIncomeParams
> = async ({ loanId, row }) => {
  if (isMockServices()) return await mock(row);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: LoanIncomeDto;
  }>(`/loans/${loanId}/incomes/${row.id}`, {
    method: 'PATCH',
    // `income` is validated against `incomeType` server-side, so they must be
    // sent together.
    body: {
      incomeType: row.type,
      borrowerPairId: row.borrowerPairId ?? null,
      scope: row.scope ?? null,
      income: toLoanIncomePayload(row),
    },
  });

  if (response.data) return toIncomeSource(response.data.data);
  throw new Error('Failed to update income');
};

export default updateLoanIncome;
